import PratDashboardActions from "../../prat_actions/pratDashboard/pratDashboardActions";

const PratDashboardReducer = (
  state = { isMapCategoryLoading: false,mapCategoryHasError:false,mapCategory:[],isActivationMetricsLoading:false,activationMetricshasError:false,activationMetrics:[],
    topTenActivitieshasError:false,topTenActivities:[],isTopTenActivitiesLoading:false, isPostOpsoResultLoading:false, postOpsoResult:[], postOpsoResulthasError:false,
    topBottomActivitieshasError:false, topBottomActivities:[], isTopBottomActivitiesLoading:false,isTTSChartLoading:false,TTSChart:[],TTSCharthasError:false,
  DTTSChart:[],isDTTSChartLoading:false,DTTSCharthasError:false, GTMTSplit:[],isGTMTSplitLoading:false,GTMTSplithasError:false,
  channelUtilization:[], isChannelUtilizationLoading:false,channelUtilizationhasError:false,
isDttsFileDownloading:false,dttsXlsxFileDownloadHasError:false, isChannelUtiFileDownloading:false, channelUtiXlsxFileDownloadHasError:false,
isTtsFileDownloading:false, ttsXlsxFileDownloadHasError:false,
isActivationMetFileDownloading:false,activationMetXlsxFileDownloadHasError:false,
isGtMtSplitFileDownloading:false,gtMtSplitXlsxFileDownloadHasError:false},
  action
) => {
  switch (action.type) {
    case PratDashboardActions.MAP_CATEGORY_REQUEST:
      return {
        ...state,
        isMapCategoryLoading: true,
        mapCategory:[],
        mapCategoryHasError:false
      };
    case PratDashboardActions.MAP_CATEGORY_SUCCESSFUL:
      return {
        ...state,
        isMapCategoryLoading: false,
        mapCategory: action.data.data,
        mapCategoryHasError:false
      };
    case PratDashboardActions.MAP_CATEGORY_FAILED:
      return {
        ...state,
        errorMessage: {},
        isMapCategoryLoading: false,
        mapCategory:[],
        mapCategoryHasError:true
      };

      // ACTIVATION METRICS

      case PratDashboardActions.ACTIVATION_METRICS_REQUEST:
      return {
        ...state,
        isActivationMetricsLoading: true,
        activationMetrics:[],
        activationMetricshasError:false
      };
    case PratDashboardActions.ACTIVATION_METRICS_SUCCESSFUL:
      return {
        ...state,
        isActivationMetricsLoading: false,
        activationMetrics: action.data.data,
        activationMetricshasError:false
      };
    case PratDashboardActions.ACTIVATION_METRICS_FAILED:
      return {
        ...state,
        errorMessage: {},
        isActivationMetricsLoading: false,
        activationMetrics:[],
        activationMetricshasError:true
      };

      // TOP TEN ACTIVITIES

      case PratDashboardActions.TOP_ACTIVITIES_REQUEST:
      return {
        ...state,
        isTopTenActivitiesLoading: true,
        topTenActivities:[],
        topTenActivitieshasError:false
      };
    case PratDashboardActions.TOP_ACTIVITIES_SUCCESSFUL:
      return {
        ...state,
        isTopTenActivitiesLoading: false,
        topTenActivities: action.data.data,
        topTenActivitieshasError:false
      };
    case PratDashboardActions.TOP_ACTIVITIES_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTopTenActivitiesLoading: false,
        topTenActivities:[],
        topTenActivitieshasError:true
      };

      // POST OPSO RESULT

      case PratDashboardActions.POST_OPSO_REQUEST:
      return {
        ...state,
        isPostOpsoResultLoading: true,
        postOpsoResult:[],
        postOpsoResulthasError:false
      };
    case PratDashboardActions.POST_OPSO_SUCCESSFUL:
      return {
        ...state,
        isPostOpsoResultLoading: false,
        postOpsoResult: action.data.data,
        postOpsoResulthasError:false
      };
    case PratDashboardActions.POST_OPSO_FAILED:
      return {
        ...state,
        errorMessage: {},
        isPostOpsoResultLoading: false,
        postOpsoResult:[],
        postOpsoResulthasError:true
      };

      // TOP BOTTOM FIVE ACTIVITIES

      case PratDashboardActions.TOP_BOTTOM_ACTIVITIES_REQUEST:
      return {
        ...state,
        isTopBottomActivitiesLoading: true,
        topBottomActivities:[],
        topBottomActivitieshasError:false
      };
    case PratDashboardActions.TOP_BOTTOM_ACTIVITIES_SUCCESSFUL:
      return {
        ...state,
        isTopBottomActivitiesLoading: false,
        topBottomActivities: action.data.data,
        topBottomActivitieshasError:false
      };
    case PratDashboardActions.TOP_BOTTOM_ACTIVITIES_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTopBottomActivitiesLoading: false,
        topBottomActivities:[],
        topBottomActivitieshasError:true
      };

      // TTS CHART

      case PratDashboardActions.TTS_CHART_REQUEST:
      return {
        ...state,
        isTTSChartLoading: true,
        TTSChart:[],
        TTSCharthasError:false
      };
    case PratDashboardActions.TTS_CHART_SUCCESSFUL:
      return {
        ...state,
        isTTSChartLoading: false,
        TTSChart: action.data.data,
        TTSCharthasError:false
      };
    case PratDashboardActions.TTS_CHART_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTTSChartLoading: false,
        TTSChart:[],
        TTSCharthasError:true
      };

      // DTTS CHART

      case PratDashboardActions.DTTS_CHART_REQUEST:
      return {
        ...state,
        isDTTSChartLoading: true,
        DTTSChart:[],
        DTTSCharthasError:false
      };
    case PratDashboardActions.DTTS_CHART_SUCCESSFUL:
      return {
        ...state,
        isDTTSChartLoading: false,
        DTTSChart: action.data.data,
        DTTSCharthasError:false
      };
    case PratDashboardActions.DTTS_CHART_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDTTSChartLoading: false,
        DTTSChart:[],
        DTTSCharthasError:true
      };

      // GT MT SPLIT CHART

      case PratDashboardActions.GTMT_SPLIT_REQUEST:
      return {
        ...state,
        isGTMTSplitLoading: true,
        GTMTSplit:[],
        GTMTSplithasError:false
      };
    case PratDashboardActions.GTMT_SPLIT_SUCCESSFUL:
      return {
        ...state,
        isGTMTSplitLoading: false,
        GTMTSplit: action.data.data,
        GTMTSplithasError:false
      };
    case PratDashboardActions.GTMT_SPLIT_FAILED:
      return {
        ...state,
        errorMessage: {},
        isGTMTSplitLoading: false,
        GTMTSplit:[],
        GTMTSplithasError:true
      };

      // MAJOR CHANNEL UTILIZATION

      case PratDashboardActions.CHANNEL_UTILIZATION_REQUEST:
      return {
        ...state,
        isChannelUtilizationLoading: true,
        channelUtilization:[],
        channelUtilizationhasError:false
      };
    case PratDashboardActions.CHANNEL_UTILIZATION_SUCCESSFUL:
      return {
        ...state,
        isChannelUtilizationLoading: false,
        channelUtilization: action.data.data,
        channelUtilizationhasError:false
      };
    case PratDashboardActions.CHANNEL_UTILIZATION_FAILED:
      return {
        ...state,
        errorMessage: {},
        isChannelUtilizationLoading: false,
        channelUtilization:[],
        channelUtilizationhasError:true
      };

      // DTTS XLSX FILE DOWNLOAD

      case PratDashboardActions.DTTS_XLSX_DOWNLOAD_REQUEST:
      return {
        ...state,
        isDttsFileDownloading: true,
        dttsXlsxFile:[],
        dttsXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.DTTS_XLSX_DOWNLOAD_SUCCESSFUL:
      return {
        ...state,
        isDttsFileDownloading: false,
        dttsXlsxFile: action.data.data,
        dttsXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.DTTS_XLSX_DOWNLOAD_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDttsFileDownloading: false,
        dttsXlsxFile:[],
        dttsXlsxFileDownloadHasError:true
      };

      // CHANNEL UTILIZATION XLSX FILE DOWNLOAD

      case PratDashboardActions.CHANNEL_UTI_XLSX_DOWNLOAD_REQUEST:
      return {
        ...state,
        isChannelUtiFileDownloading: true,
        channelUtiXlsxFile:[],
        channelUtiXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.CHANNEL_UTI_XLSX_DOWNLOAD_SUCCESSFUL:
      return {
        ...state,
        isChannelUtiFileDownloading: false,
        channelUtiXlsxFile: action.data.data,
        channelUtiXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.CHANNEL_UTI_XLSX_DOWNLOAD_FAILED:
      return {
        ...state,
        errorMessage: {},
        isChannelUtiFileDownloading: false,
        channelUtiXlsxFile:[],
        channelUtiXlsxFileDownloadHasError:true
      };

      // TTS XLSX FILE DOWNLOAD

      case PratDashboardActions.TTS_XLSX_DOWNLOAD_REQUEST:
      return {
        ...state,
        isTtsFileDownloading: true,
        ttsXlsxFile:[],
        ttsXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.TTS_XLSX_DOWNLOAD_SUCCESSFUL:
      return {
        ...state,
        isTtsFileDownloading: false,
        ttsXlsxFile: action.data.data,
        ttsXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.TTS_XLSX_DOWNLOAD_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTtsFileDownloading: false,
        ttsXlsxFile:[],
        ttsXlsxFileDownloadHasError:true
      };

      // ACTIVATION METRICS XLSX FILE DOWNLOAD

      case PratDashboardActions.ACTIVATION_MET_XLSX_DOWNLOAD_REQUEST:
      return {
        ...state,
        isActivationMetFileDownloading: true,
        activationMetXlsxFile:[],
        activationMetXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.ACTIVATION_MET_XLSX_DOWNLOAD_SUCCESSFUL:
      return {
        ...state,
        isActivationMetFileDownloading: false,
        activationMetXlsxFile: action.data.data,
        activationMetXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.ACTIVATION_MET_XLSX_DOWNLOAD_FAILED:
      return {
        ...state,
        errorMessage: {},
        isActivationMetFileDownloading: false,
        activationMetXlsxFile:[],
        activationMetXlsxFileDownloadHasError:true
      };

      // GT MT SPLIT XLSX FILE DOWNLOAD

      case PratDashboardActions.GT_MT_SPLIT_XLSX_DOWNLOAD_REQUEST:
      return {
        ...state,
        isGtMtSplitFileDownloading: true,
        gtMtSplitXlsxFile:[],
        gtMtSplitXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.GT_MT_SPLIT_XLSX_DOWNLOAD_SUCCESSFUL:
      return {
        ...state,
        isGtMtSplitFileDownloading: false,
        gtMtSplitXlsxFile: action.data.data,
        gtMtSplitXlsxFileDownloadHasError:false
      };
    case PratDashboardActions.GT_MT_SPLIT_XLSX_DOWNLOAD_FAILED:
      return {
        ...state,
        errorMessage: {},
        isGtMtSplitFileDownloading: false,
        gtMtSplitXlsxFile:[],
        gtMtSplitXlsxFileDownloadHasError:true
      };

    default:
      return {
        ...state
      };
    //   break;
  }
};

export default PratDashboardReducer;
